import type { AdminRole } from '@/types/auth';

// ── MFA ──
// Mirrors backend MFA_REQUIRED_ROLES constant exactly (app/core/constants.py).
export const MFA_REQUIRED_ROLES: readonly AdminRole[] = ['super_admin', 'finance_admin'];

// ── Token storage ──
export const STORAGE_KEYS = {
  REFRESH_TOKEN: 'wts_admin_rt',
  ADMIN_DATA: 'wts_admin_data',
} as const;

// Refresh the access token this many seconds before expiry to avoid clock-skew rejections.
export const TOKEN_REFRESH_BUFFER_SECONDS = 60;

// ── Role display labels ──
// Mirrors the 10 roles in wts_db AdminRole enum exactly.
export const ROLE_LABELS: Record<AdminRole, string> = {
  super_admin: 'Super Admin',
  content_manager: 'Content Manager',
  content_approver: 'Content Approver',
  marketing_manager: 'Marketing Manager',
  monetisation_manager: 'Monetisation Manager',
  finance_admin: 'Finance Admin',
  support_admin: 'Support Admin',
  story_review_manager: 'Story Review Manager',
  analyst: 'Analyst',
  technical_admin: 'Technical Admin',
};
